import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";

Vue.use(InfiniteLoading);
